// Get elements
const openNavSearchBox = document.querySelectorAll(".adm-btn-nav-mobile")[2];
const searchBoxContainerMobile = openNavSearchBox?.nextElementSibling;
const deleteTextBtnMobile = document.getElementById("delete-text-button-mobile");
const searchInputMobile = document.getElementById("search-box-input-mobile");
const mainDarkBackgroundMobile = searchBoxContainerMobile?.nextElementSibling;
const searchBoxContainerChild = searchBoxContainerMobile?.firstElementChild;
const mobileHeaderSearchForm = searchBoxContainerChild?.firstElementChild;
const mobileHeader = document.querySelector(".adm-nav-header-mobile");
const submitSearchMobile = document.querySelector("#submit-mobile-search");
const typeaheadContainerMobile = mainDarkBackgroundMobile?.nextElementSibling;
const typeaheadScrollerMobile = typeaheadContainerMobile?.firstElementChild;

// Display Search Box
openNavSearchBox?.addEventListener("click", () => {
    if (searchBoxContainerMobile?.classList.contains('adm-div-search-mobile-display')) {
        closeMobileSearchBox();
    } else {
        searchInputMobile?.setAttribute("tabindex", "0");
        submitSearchMobile?.setAttribute("tabindex", "0");
        searchInputMobile?.setAttribute("aria-hidden", "false");
        submitSearchMobile?.setAttribute("aria-hidden", "false");
        searchBoxContainerMobile?.setAttribute("aria-hidden", "false");
        mobileHeaderSearchForm?.setAttribute("aria-hidden", "false");
        if (deleteTextBtnMobile?.style.display === "block") {
            deleteTextBtnMobile?.setAttribute("tabindex", "0");
            deleteTextBtnMobile?.setAttribute("aria-hidden", "false");
        }
        searchBoxContainerMobile?.classList.add('adm-div-search-mobile-display');
        mainDarkBackgroundMobile?.classList.add('adm-div-dark-background-mobile-active');
        searchBoxContainerChild?.classList.add('adm-div-searchbox-display');
        openNavSearchBox?.classList.add('adm-btn-nav-mobile-active');
        mobileHeader?.parentElement?.classList.add("scroll-listener", "mobile-header");
        // setTimeout(() => {
        searchInputMobile?.focus();
        // }, 400);
    }
});

// Display delete button on user input
searchInputMobile?.addEventListener("input", () => {
    if (searchInputMobile?.value === "" || searchInputMobile.value.trim().length === 0) {
        deleteTextBtnMobile.style.display = "none";
        deleteTextBtnMobile?.setAttribute("tabindex", "-1");
        deleteTextBtnMobile?.setAttribute("aria-hidden", "true");
    } else {
        deleteTextBtnMobile.style.display = "block";
        deleteTextBtnMobile?.setAttribute("tabindex", "0");
        deleteTextBtnMobile?.setAttribute("aria-hidden", "false");
    }
});

// Delete user input
deleteTextBtnMobile?.addEventListener("click", () => {
    searchInputMobile.value = "";
    deleteTextBtnMobile.style.display = "none";
    deleteTextBtnMobile?.setAttribute("tabindex", "-1");
    deleteTextBtnMobile?.setAttribute("aria-hidden", "true");
    searchInputMobile?.focus();

    // Close typeahead
    typeaheadContainerMobile?.classList.remove("adm-div-search-mobile-typeahead-container-active");
});

// Redirect user on search
submitSearchMobile?.addEventListener('click', (event) => {
    event.preventDefault();
    let searchInputValue = searchInputMobile?.value;
    let searchPageUrl = searchInputMobile?.getAttribute("data-searchurl");
    let encoded = encodeURIComponent(searchInputValue);
    window.location.href = searchPageUrl + "?q=" + encoded;
})


// ----------- TYPEAHEAD -------------
let typeaheadTimeoutMobile;
let typeaheadOldResultsMobile = [];

// Listen to any user input
searchInputMobile?.addEventListener("input", () => {
    const trigger = searchInputMobile.getAttribute("data-type-ahead-trigger");

    // Set a timeout after user stop input
    clearTimeout(typeaheadTimeoutMobile);
    typeaheadTimeoutMobile = setTimeout(async () => {

        // Get relevant data
        let searchInputValue = encodeURIComponent(searchInputMobile?.value);

        // Set request destination
        let reqPath = window.location.origin + "/FloatingSearchBlock/TypeaheadSearch?query=" + searchInputValue;

        if (searchInputValue.length >= +trigger) {

            try {
                let response = await fetch(reqPath, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    }
                });

                let searchResultsMobile = await response.json();

                if (searchResultsMobile.results[0]) {
                    displaySearchResults(searchResultsMobile);
                    
                } else {

                    // Remove old results
                    for (let oldResult of typeaheadOldResultsMobile) {
                        oldResult.remove();
                    }

                    // Close typeahead
                    typeaheadContainerMobile?.classList.remove("adm-div-search-mobile-typeahead-container-active");

                }

            } catch (err) {
                // Error handling
                console.log('Something went wrong');
            }
        } else if (searchInputValue.length === 0) {

            // Close typeahead
            typeaheadContainerMobile?.classList.remove("adm-div-search-mobile-typeahead-container-active");

        }
    }, 1000);
});

function displaySearchResults(searchResultsMobile) {
    // Display typeahead container
    typeaheadContainerMobile?.classList.add("adm-div-search-mobile-typeahead-container-active");

    // Remove old results
    for (let oldResult of typeaheadOldResultsMobile) {
        oldResult.remove();
    }

    // Iterate through the results
    for (let result of searchResultsMobile.results) {
        const title = result.title || result.Title;
        const excerpt = result.excerpt || result.Excerpt;
        const link = result.pageUrl.linkUrl || result.pageUrl.LinkUrl;

        // Create an element for each result
        const resultBlock = document.createElement('div');
        resultBlock.className = "adm-div-search-util-typeahead-block";
        resultBlock.innerHTML = `
            <a href="${link}">
                <p class="adm-font-default adm-text-black adm-p-typeahead-title">${title}</p>
                <p class="adm-font-small adm-p-typeahead-excerpt">${excerpt}</p>
            </a>
        `;
        typeaheadScrollerMobile?.append(resultBlock);
        typeaheadOldResultsMobile?.push(resultBlock);
    }
}


// Close search box
window.addEventListener('click', function (e) {
    if (
        !searchBoxContainerMobile?.contains(e.target) &&
        !openNavSearchBox?.contains(e.target)
    ) {
        if (searchBoxContainerMobile?.classList.contains('adm-div-search-mobile-display')
            && !typeaheadContainerMobile?.classList.contains("adm-div-search-mobile-typeahead-container-active")) {
            closeMobileSearchBox();
        }
    }
})

typeaheadContainerMobile?.addEventListener("focusout", () => {
    setTimeout(() => {
        if (
            !searchBoxContainerMobile?.contains(document.activeElement) &&
            !typeaheadContainerMobile?.contains(document.activeElement)
        ) {
            closeMobileSearchBox();
        }
    }, 0);
})

// Functions
const closeMobileSearchBox = () => {
    deleteTextBtnMobile?.setAttribute("tabindex", "-1");
    searchInputMobile?.setAttribute("tabindex", "-1");
    submitSearchMobile?.setAttribute("tabindex", "-1");
    deleteTextBtnMobile?.setAttribute("aria-hidden", "true");
    searchInputMobile?.setAttribute("aria-hidden", "true");
    submitSearchMobile?.setAttribute("aria-hidden", "true");
    searchBoxContainerMobile?.setAttribute("aria-hidden", "true");
    mobileHeaderSearchForm?.setAttribute("aria-hidden", "true");
    searchBoxContainerMobile?.classList.remove('adm-div-search-mobile-display');
    mainDarkBackgroundMobile?.classList.remove('adm-div-dark-background-mobile-active');
    searchBoxContainerChild?.classList.remove('adm-div-searchbox-display');
    typeaheadContainerMobile?.classList.remove("adm-div-search-mobile-typeahead-container-active");
    openNavSearchBox?.classList.remove("adm-btn-nav-mobile-active");
    mobileHeader?.parentElement?.classList.remove("scroll-listener", "mobile-header");
    clearTimeout(typeaheadTimeoutMobile);
    openNavSearchBox.focus();
    openNavSearchBox.blur();
}